import API from 'services/api';

export const deleteCalculationGuest = ({
  calculationId,
  guestId,
}: {
  calculationId: string;
  guestId: string;
}) => {
  return API.delete(`api/accommodation/calculations/${calculationId}/guests/${guestId}`);
};
